// removed by extract-text-webpack-plugin
module.exports = {"container":"_2mt4BWBYaBMUtW5KQjH1CJ","canvas":"XILbTPiojx5mZo6-6Pzu5","name":"_2BW2ff7XX-xt1PzMcLG6t5"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/Main.css
// module id = 92
// module chunks = 0